// extracted by mini-css-extract-plugin
export default {"container":"SkeletonSelectDefault_container__LN-Y1","itemCenter":"SkeletonSelectDefault_itemCenter__6neiB","wrapper":"SkeletonSelectDefault_wrapper__voJj9"};